export const ArrowUpIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 19"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.616 9.241c-.231.23-.539.346-.846.346-.347 0-.654-.115-.885-.346L9.846 5.203v11.769a1.24 1.24 0 0 1-1.23 1.23c-.616 0-1.231-.538-1.231-1.23V5.202l-4.077 4.04c-.462.5-1.27.5-1.73 0-.5-.462-.5-1.27 0-1.732L7.73 1.356c.462-.5 1.27-.5 1.73 0l6.155 6.154c.5.462.5 1.27 0 1.731Z"
    />
  </svg>
)
